import {
    AutoComplete,
    type AutoCompleteChangeEvent,
    type AutoCompleteCompleteEvent,
    type AutoCompleteSelectEvent,
} from 'primereact/autocomplete';
import React, { useState } from 'react';

type SearchableDropdownProps<T> = {
    items: T[];
    labelField: string;
    onSelect: (value: T) => void;
};

const SearchableDropdown = <T,>({
    items,
    labelField,
    onSelect,
}: SearchableDropdownProps<T>) => {
    const [value, setValue] = useState('');
    const [suggestions, setSuggestions] = useState<unknown[]>([]);

    const search = (event: AutoCompleteCompleteEvent) => {
        const matchingItems = items.filter((item) =>
            // @ts-expect-error item[labelField] should be a string
            (item[labelField] as string)
                .toLowerCase()
                .includes(event.query.toLowerCase()),
        );

        setSuggestions(matchingItems);
    };

    return (
        <AutoComplete
            dropdown
            forceSelection
            dropdownMode="current"
            value={value}
            suggestions={suggestions}
            field={labelField}
            completeMethod={search}
            onChange={(event: AutoCompleteChangeEvent) => {
                if (typeof event.value === 'string') {
                    setValue(event.value);
                } else {
                    setValue((event.value?.[labelField] ?? '') as string);
                }
            }}
            onSelect={(event: AutoCompleteSelectEvent) => {
                onSelect(event.value as T);
            }}
        />
    );
};

export default SearchableDropdown;
